import { c as _c } from "react/compiler-runtime";
interface RostoCsatProps {
  nota: number;
  tamanho?: number;
}
const BOCA_POR_NOTA: Record<number, string> = {
  1: 'M16 16s-1.5-2-4-2-4 2-4 2',
  2: 'M16 15.5s-1.5-1-4-1-4 1-4 1',
  4: 'M8 14.5s1.5 1 4 1 4-1 4-1',
  5: 'M8 13s1.5 3 4 3 4-3 4-3'
};
export function RostoCsat(t0) {
  const $ = _c(8);
  const {
    nota,
    tamanho: t1
  } = t0;
  const tamanho = t1 === undefined ? 24 : t1;
  const boca = BOCA_POR_NOTA[nota];
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <circle cx="12" cy="12" r="10" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== boca) {
    t3 = boca ? <path d={boca} /> : <line x1="8" y1="15" x2="16" y2="15" />;
    $[1] = boca;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <line x1="9" y1="9" x2="9.01" y2="9" />;
    t5 = <line x1="15" y1="9" x2="15.01" y2="9" />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== tamanho) {
    t6 = <svg width={tamanho} height={tamanho} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{t2}{t3}{t4}{t5}</svg>;
    $[5] = t3;
    $[6] = tamanho;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}